import { formatTemplate, onTranslationsApplied, t } from './localization.ts';

let years: number = 0;
let days: number = 0;
let hours: number = 0;
let minutes: number = 0;
let seconds: number = 0;

const inlineCountdownSelector = '[data-countdown-el]';
let countdownTimerId: number | null = null;

function getCountdownTargets(): HTMLElement[] {
  const targets: HTMLElement[] = [];
  const countdownEl = document.getElementById('countdown');
  if (countdownEl) targets.push(countdownEl);
  document
    .querySelectorAll(inlineCountdownSelector)
    .forEach((el) => targets.push(el as HTMLElement));
  return targets;
}

function updateCountdownText(): void {
  const targets = getCountdownTargets();
  if (!targets.length) return;
  const template = t(
    'banner.red.countdownFormat',
    '{{years}}y {{days}}d {{hours}}h {{minutes}}m {{seconds}}s'
  );
  const text = formatTemplate(template, { years, days, hours, minutes, seconds });
  targets.forEach((el) => {
    el.textContent = text;
  });
}

function tickCountdown(): void {
  seconds--;
  if (seconds < 0) {
    seconds = 59;
    minutes--;
    if (minutes < 0) {
      minutes = 59;
      hours--;
      if (hours < 0) {
        hours = 23;
        days--;
        if (days < 0) {
          days = 364;
          years--;
        }
      }
    }
  }
  updateCountdownText();
}

function startCountdownIfNeeded(): void {
  if (!getCountdownTargets().length) return;
  if (countdownTimerId !== null) return;
  updateCountdownText();
  countdownTimerId = window.setInterval(tickCountdown, 1000);
}

function initCountdown(): void {
  startCountdownIfNeeded();
  onTranslationsApplied(updateCountdownText);
}

export { initCountdown, startCountdownIfNeeded, updateCountdownText };
